import { BLOCKS } from '@contentful/rich-text-types';
import { twMerge } from 'tailwind-merge';

import { THEME_CLASSNAMES } from '@boss/constants/corporate-jobs';
import { RichText } from '@boss/rich-text';
import type { FaqFields, ThemeColor } from '@boss/types/corporate-jobs';

import ComponentMapper from '../ComponentMapper';

export const getFaqProps = (entry: FaqFields, locale: string, themeColor?: ThemeColor, hasBackground?: boolean) => {
  const { question, answer } = entry;
  const themeClassName = themeColor ? THEME_CLASSNAMES.text[themeColor] : '';
  const textQuestionClassName = hasBackground ? 'text-white' : themeClassName;

  return {
    title: (
      <RichText
        ComponentMapper={ComponentMapper}
        className={textQuestionClassName}
        content={question}
        mapperOptions={{ locale }}
        renderNode={{
          [BLOCKS.PARAGRAPH]: (_, children) => <h5 className="h4 mb-4">{children}</h5>,
        }}
      />
    ),
    children: <ComponentMapper background={hasBackground} entry={answer} locale={locale} />,
    iconClassName: twMerge('text-faq md:text-faq', textQuestionClassName),
    titleClassName: twMerge('text-faq', textQuestionClassName),
    hasVideo: false,
    hideDivider: true,
    noIndent: true,
  };
};

export default getFaqProps;
